var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aspect-ratio-wrapper"},[_c('iframe',{ref:"iframe",staticClass:"game-engine",attrs:{"src":"/sketch.html"},on:{"load":_vm.onIframeLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }